
export class Validators {
    static isOnlyAlphabeticAndSpaces(value: string) : boolean {
        return /^[a-zA-Z\s]+$/.test(value);
    }
}